var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataSegregation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 76.867 79.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16744",
    "data-name": "Group 16744",
    transform: "translate(-1399.5 -1540)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32472",
    "data-name": "Path 32472",
    d: "M34.253,2A19.253,19.253,0,1,0,53.506,21.253,19.253,19.253,0,0,0,34.253,2Z",
    transform: "translate(1384.5 1538)",
    fill: "#ffd2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16743",
    "data-name": "Group 16743",
    transform: "translate(1408.982 1545.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32473",
    "data-name": "Path 32473",
    d: "M91.971,65.069a4.938,4.938,0,0,0-2.7.8L84.96,61.557l.018-6.693a14.855,14.855,0,0,0-1.507-29.633H77.326a17.5,17.5,0,0,0-34.938.538,15.222,15.222,0,0,0-7.417,5.021A14.842,14.842,0,0,0,45.037,54.864l.018,6.693-4.313,4.313a4.977,4.977,0,1,0,1.47,1.47l4.618-4.618a1.04,1.04,0,0,0,.3-.738l-.019-7.044h3.194V76.989c0,3.536,7.394,5.387,14.7,5.387s14.7-1.85,14.7-5.387V54.94H82.9l-.019,7.044a1.04,1.04,0,0,0,.3.738L87.8,67.34a4.967,4.967,0,1,0,4.169-2.271ZM38.044,72.928a2.89,2.89,0,1,1,2.89-2.89A2.893,2.893,0,0,1,38.044,72.928ZM65.008,80.3c-8.164,0-12.617-2.185-12.617-3.307v-5.93c2.709,1.638,7.683,2.483,12.617,2.483s9.909-.845,12.617-2.483v5.93C77.625,78.112,73.172,80.3,65.008,80.3Zm0-8.834c-8.164,0-12.617-2.185-12.617-3.307v-5.93c2.709,1.638,7.683,2.483,12.617,2.483s9.909-.845,12.617-2.483v5.93C77.625,69.278,73.172,71.463,65.008,71.463Zm0-8.834c-8.164,0-12.617-2.185-12.617-3.307v-5.93c2.709,1.638,7.683,2.483,12.617,2.483s9.909-.845,12.617-2.483v5.93C77.625,60.444,73.172,62.629,65.008,62.629ZM52.39,50.488c0-1.122,4.454-3.307,12.617-3.307s12.617,2.185,12.617,3.307-4.453,3.307-12.617,3.307S52.39,51.61,52.39,50.488Zm27.314,0c0-3.536-7.393-5.387-14.7-5.387s-14.7,1.85-14.7,5.387v2.373H46.545a12.811,12.811,0,0,1-2.887-25.284,1.04,1.04,0,0,0,.792-1.01,15.421,15.421,0,0,1,30.841-.282,1.04,1.04,0,0,0,1.04,1.025h7.14a12.775,12.775,0,1,1,0,25.55H79.7V50.488Zm12.267,22.44a2.89,2.89,0,1,1,2.89-2.89A2.893,2.893,0,0,1,91.971,72.928Z",
    transform: "translate(-31.69 -9)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32474",
    "data-name": "Path 32474",
    d: "M58.482,56.483a1.038,1.038,0,0,1-1.2.852,26.044,26.044,0,0,1-3.034-.688,1.04,1.04,0,0,1,.59-1.994,24,24,0,0,0,2.79.631A1.04,1.04,0,0,1,58.482,56.483Zm0,8.834a1.038,1.038,0,0,1-1.2.852,26.015,26.015,0,0,1-3.034-.688,1.04,1.04,0,0,1,.59-1.994,23.941,23.941,0,0,0,2.79.631A1.04,1.04,0,0,1,58.482,65.316Zm0,8.834a1.038,1.038,0,0,1-1.2.852,26.015,26.015,0,0,1-3.034-.688,1.04,1.04,0,0,1,.59-1.994,23.938,23.938,0,0,0,2.79.631A1.04,1.04,0,0,1,58.482,74.15Z",
    transform: "translate(-30.523 -6.561)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSegregation);
export default __webpack_public_path__ + "static/media/DataSegregation.bb7c4a28287b788fab68d930ae40e765.svg";
export { ForwardRef as ReactComponent };